import { Directive, Input, forwardRef, Attribute } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn, Validators } from '@angular/forms';

/** phone number must match two reg exressions */
export function allowedPhoneNumberValidator(): ValidatorFn {

  // tslint:disable-next-line:max-line-length
  const patt1 = new RegExp(/^\(?(?:(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?\(?(?:0\)?[\s-]?\(?)?|0)(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}|\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4}|\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3})|\d{5}\)?[\s-]?\d{4,5}|8(?:00[\s-]?11[\s-]?11|45[\s-]?46[\s-]?4\d))(?:(?:[\s-]?(?:x|ext\.?\s?|\#)\d+)?)$/);
  const patt2 = new RegExp(/^\(?(?:(?:0(?:0|11)\)?[\s-]?\(?|\+)(44)\)?[\s-]?\(?(?:0\)?[\s-]?\(?)?|0)([1-9]\d{1,4}\)?[\s\d-]+)(?:((?:x|ext\.?\s?|\#)\d+)?)$/);

  return (control: AbstractControl): {[key: string]: any} => {
    let validNumber = patt1.test(control.value);
    if (validNumber) {
      validNumber = patt2.test(control.value);
    }
    return validNumber ? null : {'allowedPhoneNumber': {value: control.value}} ;
  };
}

@Directive({
  selector: '[soldPhoneValidator]',
  providers: [{provide: NG_VALIDATORS, useExisting: PhoneValidatorDirective, multi: true}]
})
export class PhoneValidatorDirective implements Validator {

   // @Input() soldPhoneValidator: string;  //input useful for another potential custom validator e.g. soldPhoneValidator="bob"

   validate(control: AbstractControl): {[key: string]: any} {
      // return this.soldPhoneValidator ? allowedPhoneNumberValidator()(control)
      // : null;
      return allowedPhoneNumberValidator()(control);
    }
}



// WEBPACK FOOTER //
// D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/src/app/viewingForm/phone-validator.directive.ts